var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsAdjustVertically(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.6667C11.7015 14.6667 12 14.3682 12 14V11.3334H10.6667V14C10.6667 14.3682 10.9651 14.6667 11.3333 14.6667Z",
    fill: "#485D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14C5.33333 14.3682 5.03486 14.6667 4.66667 14.6667C4.29848 14.6667 4 14.3682 4 14V6.00004H5.33333V14Z",
    fill: "#485D7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.66671H4V2.00004C4 1.63185 4.29848 1.33337 4.66667 1.33337C5.03486 1.33337 5.33333 1.63185 5.33333 2.00004V4.66671Z",
    fill: "#485D7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H10.6667V2.00004C10.6667 1.63185 10.9651 1.33337 11.3333 1.33337C11.7015 1.33337 12 1.63185 12 2.00004V10Z",
    fill: "#485D7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 5.33337C6.6665 6.43794 5.77107 7.33337 4.6665 7.33337C3.56193 7.33337 2.6665 6.43794 2.6665 5.33337C2.6665 4.2288 3.56193 3.33337 4.6665 3.33337C5.77107 3.33337 6.6665 4.2288 6.6665 5.33337ZM5.33317 5.33337C5.33317 5.70156 5.03469 6.00004 4.6665 6.00004C4.29831 6.00004 3.99984 5.70156 3.99984 5.33337C3.99984 4.96518 4.29831 4.66671 4.6665 4.66671C5.03469 4.66671 5.33317 4.96518 5.33317 5.33337Z",
    fill: "#485D7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3332 10.6667C13.3332 11.7713 12.4377 12.6667 11.3332 12.6667C10.2286 12.6667 9.33316 11.7713 9.33316 10.6667C9.33316 9.56214 10.2286 8.66671 11.3332 8.66671C12.4377 8.66671 13.3332 9.56214 13.3332 10.6667ZM11.9998 10.6667C11.9998 11.0349 11.7014 11.3334 11.3332 11.3334C10.965 11.3334 10.6665 11.0349 10.6665 10.6667C10.6665 10.2985 10.965 10 11.3332 10C11.7014 10 11.9998 10.2985 11.9998 10.6667Z",
    fill: "#485D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAdjustVertically);
export default __webpack_public_path__ + "static/media/settingsAdjustVertically.b86ecf94.svg";
export { ForwardRef as ReactComponent };